import { FormProvider, useForm } from 'react-hook-form';
import { useCallback } from 'react';
import ControlledInput from '../../components/ControlledInput';
import BtnFilled from '../../components/BtnFilled';
import * as React from 'react';
import { COMMON_FORM_ERRORS } from '../../constants';
import { quickSignUpApi } from '../../api/api';
import { useThrottle } from '../../hooks';
import { toast } from 'react-toastify';
import { useRegisteredUsersStore } from './state/use-registered-users-store';
import useGetRole from '../../hooks/use-role';

const QuickRegistrationForm = ({ setShowModal }) => {
  const methods = useForm({ mode: 'onTouched' });
  const { fetchRegisteredUsers } = useRegisteredUsersStore();
  const { role } = useGetRole();

  const successHandle = async () => {
    setShowModal(false);
    methods.reset();
    toast.success('Пользователь успешно зарегистрирован');
    await fetchRegisteredUsers();
  };

  const throttleSubmit = useThrottle(async (data) => {
    await quickSignUpApi(data, successHandle, (err) => toast.error(err.error));
  }, 500);

  const handleSubmit = useCallback(
    (data) => {
      throttleSubmit({ user: { ...data, username: data?.email, role } });
    },
    [throttleSubmit]
  );

  const inputs = [
    // { name: 'username', label: 'Введите логин', type: 'text', placeholder: 'Логин' },
    { name: 'email', type: 'email', label: 'Введите Email', placeholder: 'someone@example.com' },
    { name: 'fio', type: 'text', label: 'Введите ФИО', placeholder: 'Иванов Иван Иванович' },
    { name: 'phone', type: 'text', label: 'Введите номер телефона', placeholder: '+79311111111', mask: '+79999999999' },
  ];

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        {inputs.map((input) => {
          return (
            <ControlledInput
              rules={{
                required: {
                  value: true,
                  message: COMMON_FORM_ERRORS.REQUIRED,
                },
              }}
              key={input.name}
              {...input}
            />
          );
        })}
        <BtnFilled disabled={!methods.formState.isValid} className={'w-max flex mx-auto'} type={'submit'} title={'Зарегистрировать'} />
      </form>
    </FormProvider>
  );
};

export default QuickRegistrationForm;
